import { render } from "./EmployeeGeneralChange.vue?vue&type=template&id=5e2ee11b&scoped=true"
import script from "./EmployeeGeneralChange.vue?vue&type=script&lang=js"
export * from "./EmployeeGeneralChange.vue?vue&type=script&lang=js"

import "./EmployeeGeneralChange.vue?vue&type=style&index=0&id=5e2ee11b&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2ee11b"]])

export default __exports__